import { ChartPieIcon } from '@heroicons/react/24/solid';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import Dataviz from '../../../components/DataViz';
import { PreviewSaraPresentation, SaraPresentation } from '../../../components/SaraPresentation';
import Spinner from '../../../components/Spinner';
import Tabs from '../../../components/Tabs';
import WebsiteTab from '../../../components/WebsiteTab';
import { getSubscribe } from '../../../features/forfait/forfaitSlice';
import { selectUserInfo } from '../../../features/users/userInfoSlice';
import { fetchWebsites } from '../../../features/websites/websitesSlice';

const subTabs = ['Acquisition', "Engagement", "Conversion"];

function Acquisition() {
  const dispatch = useDispatch();
  const userInfoContext = useSelector(selectUserInfo)
  const activeWebsite = useSelector(state => state.websites.activeWebsite)
  const subscribe = useSelector(state => state.subscriptions);
  const [open, setOpen] = useState(false)

  useEffect(() => {
    if (!subscribe.product_id) return
    dispatch(getSubscribe({ company_id: userInfoContext?.user?.company_id }))
    dispatch(fetchWebsites({ company_id: userInfoContext?.user?.company_id }))
  }, [])

  if (subscribe.loadingSubscription && !subscribe.product_id)
    return (
      <div className="w-full mx-auto flex justify-center mt-40">
        <Spinner />
      </div>
    );

  if (!localStorage.getItem(userInfoContext?.user?.email) && !subscribe.loadingSubscription && !subscribe.product_id && subscribe.products.length > 0 && userInfoContext?.user?.company?.legal_name && userInfoContext?.user?.company?.siren) return <Redirect to="/account/forfait" />;
  if (!subscribe.loadingSubscription && !subscribe.product_id && subscribe.products.length > 0) return <Redirect to="/account" />;

  return (
    <div className="space-y-8 relative pb-4">
      <PreviewSaraPresentation title='Présentation SARA TRAFIC' open={open} setOpen={setOpen} />
      <div className="max-w-md mx-auto mt-10">
        <WebsiteTab />
      </div>
      <Tabs tabs={subTabs} panels={[<FollowVisitor />, <FollowVisitor />, null]} />
      <SaraPresentation reOpen={open} title='Présentation SARA TRAFIC' activeWebsite={activeWebsite}>
        Vous retrouverez dans cette rubrique le suivi de vos résultats de trafic (visites) au global et par source. <br /><br />
        Je vous accompagne à comprendre facilement où vous en êtes en comparaison à votre historique. <br /><br />
        Mon suivi vous permet de savoir rapidement si la tendance est bonne, si certaines sources de trafic sur-performent ou sous-performent. <br /><br />
        Ce suivi, ne vous permets pas, en revanche, à lui seul, de prendre vos décisions business (il faut pour cela que vous ayez une vision jusqu'à la conversion) mais, il vous permettra de savoir déjà si vos actions globales ont un impact sur votre trafic de visites et quelle source vous génère le plus de visibilité. <br /><br />
        Afin de me permettre de mettre en place vos tableaux de pilotage « Analytics » les plus personnalisés que possible, vous devez échanger avec nos experts pour qu’ils comprennent bien vos besoins et attentes. <br /> <br />
        Je vous invite  donc à prendre RDV dès à présent pour votre échange ONBOARDING
      </SaraPresentation>
    </div>
  );
}

const FollowVisitor = () => {
  return <div className="w-full mx-auto px-10 relative flex flex-col items-center justify-center space-y-0.5 bg-gray-50">
    <iframe
      className="rounded-3xl"
      width="1224"
      height="800"
      id='dataviz-indicator'
      src="https://azatys.clicdata.com/v/HoDUDYx84jOa"
    >
    </iframe>
  </div>
}

export default Acquisition;


export function FullScreenIcon(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 21 21" {...props}><path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M18.5 7.5V2.522l-5.5.014m5.5-.014l-6 5.907m.5 10.092l5.5.002l-.013-5.5m.013 5.406l-6-5.907M2.5 7.5v-5H8m.5 5.929l-6-5.907M8 18.516l-5.5.007V13.5m6-1l-6 6"></path></svg>
  )
}